
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseContainer } from '@stylehaven/components';
import { RouterOutlet } from '@angular/router';

@Component({
    standalone: true,
    selector: 'med-sharing-wrapper',
    templateUrl: './sharing-wrapper.container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, RouterOutlet]
})
export class SharingWrapperContainerComponent extends BaseContainer {
    private _isNavigatingAway: boolean = false;

    public setNavigatingAway(): void {
        this._isNavigatingAway = true;
    }

    public get isNavigatingAway(): boolean {
        return this._isNavigatingAway;
    }
}
